$(function () {
    // Initialize multiselect dropdowns
    // get a handle
    var search = $('.wt-search-section');

    // check if we are on the search page
    if (search.length > 0) {

        GetSearchPagedData(1);
    }

    $('#searchDisplayAmts').change(function () {
        GetSearchPagedData(1);
    });

});

function GetSearchPagedData(pageNum) {
    // get a handle
    var searchContainer = $('.search-items');
    var loader = $('.search__loading');
    var pagination = $('.pagination');
    var noSearchItems = $('.no-search-items');
    var searchType = $('#searchFilter').val();

    var resultsContainer = $('.results-data');
    var starting = resultsContainer.find('.starting-number');
    var totalDisplayed = resultsContainer.find('.total-displayed');
    var total = resultsContainer.find('.total');

    searchContainer.hide();
    noSearchItems.hide();
    loader.show();

    var searchText = $('#searchInput').val();
    var newUrl = '?';

    if (searchText != null && searchText != '') {
        newUrl += 'ss=' + searchText;
    }

    // update url history to save this ajax selection
    if (newUrl != '?') window.history.replaceState(null, null, newUrl);
    else window.history.replaceState(null, null, window.location.pathname);

    var amtToDisplay = $('#searchDisplayAmts').val();
    var culture = $('body').data('culture');

    $.getJSON("/Search/GetPagedData", { ss: searchText, st: searchType, pageNumber: pageNum, pageSize: amtToDisplay, culture }, function (response) {
        if (response.data.length > 0) {
            var rowData = "";
            for (var i = 0; i < response.data.length; i++) {
                rowData += SearchListingTemplate(response.data[i]);
            }

            searchContainer.html("");
            searchContainer.append(rowData);
            pagination.html("");

            if (response.totalPages > 1) {
                var pagerTemplate = PagingTemplate(response.totalPages, response.currentPage, "GetSearchPagedData");
                pagination.append(pagerTemplate);
            }

            total.text(response.totalItems);
            starting.text(response.startingItemNum);

            if (response.totalItemsShowing == 1) {
                totalDisplayed.text('');
            }
            else {
                totalDisplayed.text(' - ' + response.totalItemsShowing);
            }

            loader.hide();
            searchContainer.show();
        }
        else {
            loader.hide();

            totalDisplayed.text('');
            starting.text('0');
            total.text('0');

            noSearchItems.show();
        }
    });
}

function SearchListingTemplate(listItem) {

    var template = '<div class="search-item"><div class="search-item__inner">';

    if (listItem.listingImage != null) {
        template += `<div class="search-item__img"><a href="${listItem.listingButtonURL}"><img src="${listItem.listingImage.directUrlPreview}" alt="${listItem.listingImage.altText.replace('"', '&quot')}" /></a></div>`;
    }

    template += `<div class="search-item__content"><a href="${listItem.listingButtonURL}"><div class="heading">${listItem.listingTitle ?? ""}</div>`;
    template += `<div class="text">${(listItem.listingSubtitle != null & listItem.listingSubtitle != "" ? "<p>" + listItem.listingSubtitle + "</p>" : "")}${listItem.listingText ?? ""}</div></a></div></div></div>`;

    return template;
}